import { createContext } from "react";
import { Bet } from "@models";

// @ts-expect-error
export const MyBetsBetContext = createContext<Bet>(null);
